module.exports = __webpack_public_path__ + "img/icon_st02.3b77b4de.png";